import { DateRangeID } from '@fullstory/client-api';
import { intl } from '@fullstory/intl';

interface DeprecatedDateRangeOption {
  id: DateRangeID;
  label: string;
  days: number;
}

export const defaultTimeRangeOptions: DeprecatedDateRangeOption[] = [
  {
    id: DateRangeID.Today,
    label: intl.formatMessage({ defaultMessage: 'Today', id: 'zWgbGg' }),
    days: 1,
  },
  {
    id: DateRangeID.Yesterday,
    label: intl.formatMessage({ defaultMessage: 'Yesterday', id: '6dIxDP' }),
    days: 1,
  },
  {
    id: DateRangeID.PastWeek,
    label: intl.formatMessage({ defaultMessage: 'Past 7 days', id: 'mbbNJS' }),
    days: 7,
  },
  {
    id: DateRangeID.PastMonth,
    label: intl.formatMessage({ defaultMessage: 'Past 30 days', id: 'OIM20v' }),
    days: 30,
  },
  {
    id: DateRangeID.Past90Days,
    label: intl.formatMessage({ defaultMessage: 'Past 90 days', id: 'ZOWtIg' }),
    days: 90,
  },
  {
    id: DateRangeID.PastYear,
    label: intl.formatMessage({ defaultMessage: 'Past 12 months', id: 'o0vS8L' }),
    days: 365,
  },
  {
    id: DateRangeID.AllTime,
    label: intl.formatMessage({ defaultMessage: 'All time', id: 's+lPP3' }),
    days: Number.POSITIVE_INFINITY,
  },
  {
    id: DateRangeID.Since,
    label: intl.formatMessage({ defaultMessage: 'Since', id: '+eH89J' }),
    days: 0,
  },
  {
    id: DateRangeID.Custom,
    label: intl.formatMessage({ defaultMessage: 'Custom', id: 'Sjo1P4' }),
    days: 0,
  },
];
